import { STANDARD_RETURN_POLICY_HTML } from '@client/constants';
import { DELIVERY_ESTIMATE_UNAVAILABLE_TEXT, ReturnPolicyType, } from '@heirloom/common/constants';
import { HEIRLOOM_LISTING_PROFILES } from '@heirloom/common/domain/listing';
import { calculateDeliveryEstimate } from '@heirloom/common/utils/dateUtils';
export const getReturnPolicyDisplay = (returnPolicy) => {
    let text = returnPolicy
        ? 'No returns'
        : 'Returns info unavailable';
    if (returnPolicy &&
        returnPolicy.policyType !== ReturnPolicyType.NO_RETURNS &&
        (returnPolicy.returnWindowDays ?? 0) > 0) {
        text = `Returns accepted within ${returnPolicy.returnWindowDays} days`;
    }
    const descriptionHtml = returnPolicy?.policyType === ReturnPolicyType.STANDARD
        ? STANDARD_RETURN_POLICY_HTML
        : returnPolicy?.policyType === ReturnPolicyType.CUSTOM
            ? (returnPolicy.policyDescrRichText ?? null)
            : null;
    return { text, descriptionHtml };
};
export const resolveEffectiveProfiles = (listing) => listing.directFulfillment
    ? listing.profiles
    : HEIRLOOM_LISTING_PROFILES;
export const getDeliveryEstimateDisplay = (profiles) => profiles?.processing && profiles?.shipping
    ? calculateDeliveryEstimate(profiles.processing, profiles.shipping)
    : DELIVERY_ESTIMATE_UNAVAILABLE_TEXT;
